import type { SlateBlock } from '@atlas/renderer';
import { Editor, Element } from 'slate';
import ensureValidSelection from '@atlas/tool/box/slate/ensureValidSelection';

export default function isBlockActive(editor: Editor, blockType: SlateBlock['type']) {
    const { selection } = editor;
    if (!selection) return false;

    ensureValidSelection(editor);
    const [match] = Array.from(
        Editor.nodes(editor, {
            at: Editor.unhangRange(editor, selection),
            match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === blockType,
        }),
    );

    return !!match;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('isBlockActive', async () => {
        const { createEditor } = await import('slate');

        it('should return true if the block is matching', () => {
            const editor = createEditor();
            editor.children = [{ type: 'paragraph', children: [{ text: '' }] }];
            editor.selection = { anchor: Editor.start(editor, [0]), focus: Editor.end(editor, [0]) };
            expect(isBlockActive(editor, 'paragraph')).toBe(true);
        });

        it('should return false if the block is not matching', () => {
            const editor = createEditor();
            editor.children = [{ type: 'paragraph', children: [{ text: 'Hello World' }] }];
            editor.selection = { anchor: Editor.start(editor, [0]), focus: Editor.end(editor, [0]) };
            expect(isBlockActive(editor, 'block-quote')).toBe(false);
        });
    });
}
